var _defs, _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCoeur4(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Calque_1",
    "data-name": "Calque 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 425.2 294.59",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#e1251b;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M263.87,81c-9.7-.06-19.45,3.89-27.27,9.47s-12.43,17.15-20.75,21c-9.84,4.52-25.24-4.81-37.07-6a53.44,53.44,0,0,0-28.84,4.82c-17.76,8.66-25.68,25.91-21.78,45.12,4.94,24.42,23.78,42.94,43.28,56.87,28.62,20.44,59.65,38,89.43,56.67,10.09,6.33,22.25-7.43,12.74-14.47a8.73,8.73,0,0,0,.8-1c26.14-36.73,42.66-99.07,26.65-143.12-6-16.44-18.92-29.27-37.19-29.37M283,134.58c3.64,38.44-9.88,74.19-25.35,108.47a7.81,7.81,0,0,0-.34.87c-28.65-18.08-59.07-35.74-83.69-58.27-14.05-12.86-41-55-3-58,16.71-1.31,31.12,12.49,47.31,10.3,11.21-1.52,15.63-10.9,22-18.7,7.83-9.59,22.22-25.67,36.25-9.71,5.37,6.11,6.14,17.35,6.87,25.06"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M358.86,26.78a5.33,5.33,0,0,0-8.93-5.56c-9.83,10.59-16.52,24.46-24,36.78-4.37,7.17,7.55,12.38,11.9,5.35,7.3-11.79,16.25-23.55,21.07-36.57"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M382.94,64c-12.58,6.28-23.05,14.75-34.16,23.31-4.65,3.57.35,10.52,5.26,7.38,11.82-7.56,23.32-14.55,33.5-24.26,2.93-2.79-1-8.21-4.6-6.43"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M68.54,81.46c-9.18-4.21-15.62,10.1-6.43,14.32a88.11,88.11,0,0,1,27.28,19.7c5.72,6.17,16.13-.5,11-7.83A77.21,77.21,0,0,0,68.54,81.46"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M47.82,120.61c-11.26-3.44-16.07,12.15-4.6,15.55,9.37,2.78,19.3,6.91,29.05,7.71a7.22,7.22,0,0,0,4-13.66c-8.58-4.71-19.14-6.74-28.49-9.6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCoeur4);
export default __webpack_public_path__ + "static/media/coeur4.a4bf08ec76d5c69228ad5416188be485.svg";
export { ForwardRef as ReactComponent };